// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ngimwhepmlwsyunvyogm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5naW13aGVwbWx3c3l1bnZ5b2dtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgxNjExNzMsImV4cCI6MjA1MzczNzE3M30.FGsdIxv5cesahGSnI7Ehco7dJY85kfqDWydZGOqdSa0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);